import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"

import api from "assets/services/api";


function ModalUpdateProducts(props) {
    const [br, setBR] = useState(false);

    const [name, setName] = useState(props.props.name);
    const [full_name, setFull_name] = useState(props.props.full_name);
    const [box, setBox] = useState(props.props.box);
    const [weight, setWeight] = useState(props.props.weight);
    const [code, setCode] = useState(props.props.code);
    const [standart_price, setStandart_price] = useState(props.props.standart_price);
    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);
    const [max_for_distributors, setMax_for_distributors] = useState(props.props.max_for_distributors);
    const [two_percent, setTwo_percent] = useState(props.props.two_percent);
    const [three, setThree] = useState(props.props.three);
    const [gtin, setGtin] = useState(props.props.gtin);
    const [dun, setDun] = useState(props.props.dun);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);


    async function handleUpdateProduct(e) {
        e.preventDefault();
        const response = await api.put('/product/' + props.props.id, {
            code,
            name,
            full_name,
            standart_price,
            id_admin: storageId,
            weight,
            box,
            max_for_distributors,
            two_percent,
            three,
            gtin,
            dun
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.getAllProducts();
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar produto
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleUpdateProduct}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridProduct">
                            <Form.Label>Code</Form.Label>
                            <Form.Control onChange={event => setCode(event.target.value)} type="number" placeholder="Código do produto" value={code} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control onChange={event => setName(event.target.value)} type="text" placeholder="Nome do produto" value={name} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridFullName">
                            <Form.Label>Nome completo</Form.Label>
                            <Form.Control onChange={event => setFull_name(event.target.value)} type="text" placeholder="Nome completo do produto" value={full_name} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Quantidade por caixa</Form.Label>
                            <Form.Control onChange={event => setBox(event.target.value)} type="number" placeholder="Quantidade de produtos por caixa" value={box} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Peso por unidade</Form.Label>
                            <Form.Control onChange={event => setWeight(event.target.value)} type="decimal" placeholder="Peso por unidade" value={weight} />
                        </Form.Group>

                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridCode">
                            <Form.Label>Preço</Form.Label>
                            <MaskReal value={standart_price} onChange={value => setStandart_price(value.replace(',', '.'))} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>1° porcentagem	</Form.Label>
                            <MaskReal value={two_percent} onChange={value => setTwo_percent(value.replace(',', '.'))} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>2° porcentagem	</Form.Label>
                            <MaskReal value={three} onChange={value => setThree(value.replace(',', '.'))} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>3° porcentagem	</Form.Label>
                            <MaskReal value={max_for_distributors} onChange={value => setMax_for_distributors(value.replace(',', '.'))} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>GTIN</Form.Label>
                            <Form.Control onChange={event => setGtin(event.target.value)} type="text" placeholder="gtin" value={gtin} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>DUN</Form.Label>
                            <Form.Control onChange={event => setDun(event.target.value)} type="text" placeholder="dun" value={dun} />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Salvar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Produto editado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateProducts;